import { error } from "@sveltejs/kit";
import { p as prisma } from "../../../../../../../../chunks/prisma.js";
import fs from "fs";
import path from "path";
const GET = async ({ params, locals }) => {
  const productId = Number(params.id);
  const docId = Number(params.docId);
  if (Number.isNaN(productId) || Number.isNaN(docId)) throw error(400, "Invalid params");
  const product = await prisma.product.findUnique({ where: { id: productId, isPublished: true } });
  if (!product) throw error(404, "Product not found");
  const doc = await prisma.productDocument.findFirst({
    where: { id: docId, productId, isPublished: true }
  });
  if (!doc) throw error(404, "Document not found");
  if (!locals.isSubscribed && !(await import("../../../../../../../../chunks/auth.js")).default.isAdmin(locals.user)) {
    throw error(403, "Subscription required");
  }
  const filePath = path.join("uploads", "product-documents", String(productId), doc.storedName);
  if (!fs.existsSync(filePath)) throw error(404, "File missing");
  const stat = fs.statSync(filePath);
  const stream = fs.createReadStream(filePath);
  return new Response(stream, {
    headers: {
      "Content-Type": "application/pdf",
      "Content-Length": String(stat.size),
      "Content-Disposition": `inline; filename="${doc.originalName.replace(/"/g, "")}"`,
      "Cache-Control": "no-store"
    }
  });
};
export {
  GET
};
